import { I18n } from "../services/I18n";
import "./generated/site-translations-pl";
import common_pl from "../../../../../libs/ps/restaumatic-common/locales/pl.json";
import core_types_sites_pl from "../../../../../libs/ps/restaumatic-core-types-sites/locales/pl.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  pl: { _core_types_sites: core_types_sites_pl },
});
I18n.translations = I18n.extend(I18n.translations, {
  pl: { _common: common_pl },
});
